// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"624":"973e30f7","930":"8be6d294","3739":"fbc8fac3","9668":"973e30f7"}[chunkId] + ".chunk.css";
};